// extracted by css-extract-rspack-plugin
export default {"container":"McpDetails-module__container__bVRFl","content":"McpDetails-module__content__t4MUc","hideOnDesktop":"McpDetails-module__hideOnDesktop__SiqDd"};